import { call, put, takeLatest } from "redux-saga/effects";
import {
  GetUserNotificationsServiceInit,
  GetUserNotificationsServiceSuccess,
  GetUserNotificationsServiceFailure
} from "./UserNotificationSlice";
import { _CALLGETAPI } from "../../api/apiHandler";
import { _BROTHER_PLUS_API_ENDPOINTS, LOCALSESSIONDATAKEYS, SUCCESS } from "../../constants/AppConstants";
import i18next from "i18next";
import { handleError } from "../SagaError";
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";

function __USERNOTIFICATIONSERVICE(UID, notificationCount) {
  const endpoint = _BROTHER_PLUS_API_ENDPOINTS.GET_USER_NOTIFICATIONS;
  const payload = {
    params: {
      "userId": UID,
      "count": notificationCount
    }
  };
  return _CALLGETAPI(endpoint, payload)
    .then(response => {
      return response
    })
    .catch(error => { throw error; });
}

function* handleUserNotificationService(action) {
  try {

    const notificationCount = action.payload;
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const notificationData = yield call(__USERNOTIFICATIONSERVICE, UID, notificationCount);
    (notificationData.actionStatus.toUpperCase() === SUCCESS)
      ? yield put(GetUserNotificationsServiceSuccess(notificationData))
      : yield* handleError(GetUserNotificationsServiceFailure, i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"));
  } catch (error) {
    yield* handleError(GetUserNotificationsServiceFailure, error.message);
  }
}

export default function* watchGetUserNotificationsService() {
  yield takeLatest(GetUserNotificationsServiceInit.type, handleUserNotificationService);
}

